import { useEffect, useState } from 'react';
import { authScopesRepositorySingleton } from '../infra';

export interface UserScopes {
	scopes: string[];
	isLoading: boolean;
}

export function useUserScopes(): UserScopes {
	const [scopes, setScopes] = useState<string[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;

		authScopesRepositorySingleton
			.get()
			.getScopes()
			.then((result) => {
				if (!cancelled) setScopes(result);
			})
			.catch(() => {
				if (!cancelled) setScopes([]);
			})
			.finally(() => {
				if (!cancelled) setIsLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, []);

	return { scopes, isLoading };
}
